import NeighborhoodsItem from './neighborhood-item';
export default NeighborhoodsItem;
